export default __webpack_public_path__ + "static/media/javascript.87a03568.png";